import React, { PureComponent } from 'react';
import ShortId from 'shortid';
import Input from '@hobs/components/Input';
import Icon from '@hobs/components/Icon';

const KEY_ENTER = 13;

function WithQuickSearch(Component) {
  return class QuickSearch extends PureComponent {
    state = {
      key: ShortId.generate(),
      inputValue: null,
      withQuickSearchFilter: {}
    };

    handleQuickSearchChange = onSearch => event => {
      if (event.keyCode === KEY_ENTER) {
        this.quickSearch(event.target.value, onSearch);
      }
    };

    quickSearch = (value, onSearch) => {

      let state = {};
      if (value === '' || !value) {
        state = {
          withQuickSearchFilter: {}
        };
      } else {
        state = {
          withQuickSearchFilter: {
            logic: 'and',
            filters: [
              {
                field: 'QuickSearchField',
                operator: 'contains',
                value
              }
            ]
          }
        };
      }

      this.setState(state, () => {
        onSearch(value);
      });
    };

    withQuickSearchForm = ({ onSearch, preFilledQuickSearch, placeholder, ...props }) => {

      if (
        preFilledQuickSearch && 
        !this.state.inputValue &&
        preFilledQuickSearch !== this.state.inputValue
      ) {
        this.setState(
          {
            key: ShortId.generate(),
            inputValue: preFilledQuickSearch
          },
          this.quickSearch(preFilledQuickSearch, onSearch)
        );
      }
      return (
        <Input
          key={this.state.key}
          noMargin={props.noMargin}
          search
          className="with-quick-search"
          icon={<Icon icon="search" />}
          placeholder={placeholder || "search"}
          defaultValue={
            preFilledQuickSearch ? preFilledQuickSearch : this.state.inputValue
          }
          onKeyUp={this.handleQuickSearchChange(onSearch)}
        />
      );
    };

    render() {
      return (
        <Component
          {...this.props}
          withQuickSearchFilter={this.state.withQuickSearchFilter}
          withQuickSearchForm={this.withQuickSearchForm}
        />
      );
    }
  };
}

export default WithQuickSearch;
